<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';
  import { tenantLogado, baseUrl } from '../../Classes/Stores.js';

  const dispatch = createEventDispatcher();
  const conexao = new Conexoes();
  $: tenant = $tenantLogado;
  
  let googleCalendarId = '';
  let googleCalendarAtivo = false;
  let emailNotificacoes = '';
  let lembreteEmailAtivado = false;
  let lembreteHorasAntes = 24;
  let gcalLembreteAtivo = false;
  let gcalLembreteMinutos = 30;
  let gcalLembreteMetodo = 'popup';
  let msgConfirmacao = 'Olá {{cliente}}, sua consulta está confirmada para {{hora}} em {{local}}.';
  let msgLembrete = 'Oi {{cliente}}, passando para lembrar da nossa consulta amanhã às {{hora}} no {{local}}.';
  $: googleConnected = !!tenant?.google_access_token;

  onMount(() => {
    if (tenant) {
      googleCalendarId = tenant.google_calendar_id || '';
      googleCalendarAtivo = tenant.google_calendar_ativo == 1;
      emailNotificacoes = tenant.email_notificacoes || '';
      lembreteEmailAtivado = tenant.lembrete_email_ativado == 1;
      lembreteHorasAntes = tenant.lembrete_horas_antes || 24;
      gcalLembreteAtivo = tenant.gcal_lembrete_ativo == 1;
      gcalLembreteMinutos = tenant.gcal_lembrete_minutos || 30;
      gcalLembreteMetodo = tenant.gcal_lembrete_metodo || 'popup';
      // Carrega mensagens salvas no banco (se existirem)
      msgConfirmacao = tenant.msg_confirmacao || msgConfirmacao;
      msgLembrete = tenant.msg_lembrete || msgLembrete;
    }
  });

  function conectarGoogle() {
    const urlBaseValue = $baseUrl ? $baseUrl.replace(/\/$/, '') : null;
    if (!urlBaseValue) { dispatch('recarregar', 'A conexão com o servidor ainda está a ser iniciada.'); return; }
    const origin = window.location.origin;
    window.location.href = `${urlBaseValue}/google_auth.php?action=login&id_tenant=${tenant.id}&origin=${encodeURIComponent(origin)}`;
  }

  async function desconectarGoogle() {
    if (!confirm('Deseja realmente desligar o Google Agenda?')) return;
    dispatch('loading', true);
    const apiDesconectar = Constantes.api_acesso.replace('acesso.php', 'desconectar_google.php');
    const res = await conexao.conecta(apiDesconectar, { body: { id_tenant: tenant.id } });
    dispatch('loading', false);
    if (res?.sucesso) dispatch('recarregar', "Conta Google desligada com sucesso!");
    else dispatch('recarregar', "Erro ao desligar.");
  }

  async function sincronizarAntigos() {
    if (!confirm('Isto vai enviar todos os seus agendamentos futuros para o Google Calendar. Quer continuar?')) return;
    dispatch('loading', true);
    const apiSync = Constantes.api_acesso.replace('acesso.php', 'sincronizar_agenda.php');
    const res = await conexao.conecta(apiSync, { body: { id_tenant: tenant.id } });
    dispatch('loading', false);
    dispatch('recarregar', res?.mensagem || "Sincronização falhou.");
  }

  async function salvarConfiguracoes() {
    dispatch('loading', true);
    const res = await conexao.conecta(Constantes.api_atualizar_tenant, {
      body: { 
        id_tenant: tenant.id, 
        google_calendar_id: googleCalendarId, 
        google_calendar_ativo: googleCalendarAtivo ? 1 : 0, 
        email_notificacoes: emailNotificacoes,
        lembrete_email_ativado: lembreteEmailAtivado ? 1 : 0,
        gcal_lembrete_ativo: gcalLembreteAtivo ? 1 : 0,
        gcal_lembrete_minutos: gcalLembreteMinutos,
        gcal_lembrete_metodo: gcalLembreteMetodo,
        lembrete_horas_antes: lembreteHorasAntes,
        msg_confirmacao: msgConfirmacao,
        msg_lembrete: msgLembrete
      }
    });
    dispatch('loading', false);
    dispatch('recarregar', res?.mensagem || 'Definições gravadas!');
  }
</script>

<section class="card-panel fade-in">
  <h2>Integrações e Alertas</h2>
  
  <div class="panel-card config-card">
    <div class="config-header">
      <div class="config-icon calendar"><i class="fab fa-google"></i></div>
      <div class="config-title">
        <h3>Google Agenda</h3>
        <p>Sincronize as suas consultas com o seu calendário pessoal.</p>
      </div>
      {#if googleConnected}<div class="connected-badge"><i class="fas fa-check-circle"></i> Ligado</div>{/if}
    </div>
    
    <div class="config-body">
      {#if !googleConnected}
        <button class="btn-connect" style="margin: 0 auto;" on:click={conectarGoogle}>Ligar Conta Google</button>
      {:else}
        <div class="mt-2">
          <label>ID da Agenda</label>
          <input type="text" class="input-app" placeholder="ex: primary" bind:value={googleCalendarId} />
          <small class="text-muted" style="font-size:0.75rem; display:block; margin-top:5px;">(Deixe em branco ou escreva "primary" para usar a sua agenda principal)</small>
        </div>
        <div class="mt-2">
  <label>ID da Agenda</label>
  <input type="text" class="input-app" placeholder="ex: primary" bind:value={googleCalendarId} />
  <div class="help-box mt-2">
    <i class="fas fa-info-circle"></i>
    <span>Para encontrar o ID: No seu Google Agenda (computador), clique nos 3 pontinhos ao lado da agenda desejada > <strong>Configurações e Compartilhamento</strong> > Role até <strong>Integrar Agenda</strong> > Copie o <strong>ID da agenda</strong>.</span>
  </div>
</div>
        <div class="switch-row mt-3">
          <label class="switch"><input type="checkbox" bind:checked={googleCalendarAtivo}><span class="slider"></span></label>
          <span>Sincronização Automática Ativa</span>
        </div>
        <button class="btn-del mt-4 w-100" style="background:#fff5f5; color:#c53030; font-weight:bold;" on:click={desconectarGoogle}><i class="fas fa-unlink"></i> Desligar Google Agenda</button>
        <button class="btn-primary mt-2 w-100" style="background:#4285F4; color:white; font-weight:bold;" on:click={sincronizarAntigos}><i class="fas fa-sync-alt"></i> Sincronizar Agendamentos Futuros</button>
        
        <div style="margin-top: 25px; padding-top: 20px; border-top: 1px dashed var(--border);">
          <h4 style="margin-top:0; font-size:1rem; color:var(--primary);">Avisos para o Profissional</h4>
          <div class="switch-row mt-2">
            <label class="switch"><input type="checkbox" bind:checked={gcalLembreteAtivo}><span class="slider"></span></label>
            <span>Criar alarme/lembrete no meu Google Agenda</span>
          </div>
          {#if gcalLembreteAtivo}
            <div class="fade-in mt-3" style="background:var(--bg-app); padding:15px; border-radius:8px;">
              <label>Como deseja ser avisado do agendamento?</label>
              <div class="gcal-config-row" style="display:flex; gap:10px; margin-top:8px;">
                <select class="input-app" bind:value={gcalLembreteMetodo} style="flex:1;">
                  <option value="popup">Notificação no Telemóvel/PC</option>
                  <option value="email">E-mail automático do Google</option>
                </select>
                <select class="input-app" bind:value={gcalLembreteMinutos} style="flex:1;">
                  <option value="10">10 minutos antes</option>
                  <option value="30">30 minutos antes</option>
                  <option value="60">1 hora antes</option>
                  <option value="120">2 horas antes</option>
                  <option value="1440">1 dia antes (24h)</option>
                </select>
              </div>
            </div>
          
          {/if}
          <div class="help-box mt-3">
  <i class="fas fa-bell"></i>
  <span><strong>Dica:</strong> Estes avisos são para você, profissional, não para o cliente. Se você usa o Google Agenda no telemóvel, estes alertas tocarão como uma notificação comum de compromisso.</span>
</div>
        </div>
      {/if}
    </div>
  </div>

  <div class="panel-card config-card mt-4">
    <div class="config-header">
      <div class="config-icon email"><i class="far fa-envelope"></i></div>
      <div class="config-title">
        <h3>Lembretes por E-mail</h3>
        <p>Reduza faltas enviando avisos automáticos aos clientes.</p>
      </div>
    </div>
    
    <div class="config-body">
      <div class="switch-row mb-3">
        <label class="switch"><input type="checkbox" bind:checked={lembreteEmailAtivado}><span class="slider"></span></label>
        <span class="fw-bold">Enviar lembretes automáticos</span>
      </div>
      <div style="opacity: {lembreteEmailAtivado ? '1' : '0.5'}; pointer-events: {lembreteEmailAtivado ? 'auto' : 'none'}; transition: opacity 0.3s;">
        <div class="form-group mb-3">
          <label>E-mail para notificações (Cópia para o profissional)</label>
          <input type="email" class="input-app" bind:value={emailNotificacoes} placeholder="seu-email@exemplo.com" />
        </div>
        <label class="mt-3">Avisar o cliente quanto tempo antes da consulta?</label>
        <div class="lembrete-row" style="display:flex; align-items:center; gap: 10px;">
          <input type="number" class="input-app w-25" bind:value={lembreteHorasAntes} min="1" max="72" />
          <span>horas</span>
        </div>
        <small class="text-muted">Recomendado: 24 horas.</small>
      </div>
    </div>
  </div>
<div class="panel-card config-card mt-4">
  <div class="config-header">
    <div class="config-icon email"><i class="fas fa-pen-fancy"></i></div>
    <div class="config-title">
      <h3>Personalizar Mensagens</h3>
      <p>Configure o texto dos e-mails enviados aos clientes.</p>
    </div>
  </div>
  <div class="config-body">
    <div class="alert-info mb-3" style="background: #e3f2fd; padding: 10px; border-radius: 8px; font-size: 0.85rem;">
      <strong>Tags disponíveis:</strong> <br>
      <code>{'{{cliente}}'}</code> (Apenas Nome) | 
      <code>{'{{local}}'}</code> (Nome da Clínica/App) | <br>
      <code>{'{{endereco}}'}</code> (Rua ou Link do Zoom) | 
      <code>{'{{hora}}'}</code> (Data e Hora)
    </div>

    <label>Mensagem de Confirmação (Enviada na hora do agendamento)</label>
    <textarea 
  class="input-app" 
  rows="4" 
  bind:value={msgConfirmacao} 
  placeholder={"Olá {{cliente}}, sua consulta está confirmada para {{hora}} em {{local}}."}
></textarea>
    <label class="mt-3">Mensagem de Lembrete (Enviada via Cron)</label>
    <textarea class="input-app" rows="4" bind:value={msgLembrete} placeholder={"Oi {{cliente}}, passando para lembrar da nossa consulta amanhã às {{hora}} no {{local}}."}></textarea>
  </div>
</div>
  <button class="btn-primary mt-4 w-100" style="font-size: 1.1rem; padding: 18px;" on:click={salvarConfiguracoes}>
    <i class="fas fa-save me-2"></i> Gravar Todas as Configurações
  </button>
</section>

<style>
  .panel-card { border: 1px solid var(--border); border-radius: 12px; overflow: hidden; background: white; }
  .config-header { display: flex; align-items: center; padding: 25px; border-bottom: 1px solid var(--border); background: var(--bg-app); }
  .config-icon { width: 50px; height: 50px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; margin-right: 20px; color: white; flex-shrink: 0; }
  .config-icon.calendar { background: #4285F4; }
  .config-icon.email { background: var(--accent); }
  .config-title { flex: 1; }
  .config-title h3 { margin: 0 0 5px 0; font-size: 1.1rem; color: var(--text); }
  .config-title p { margin: 0; font-size: 0.85rem; color: #777; }
  .config-body { padding: 25px; }
  .btn-connect { background: white; border: 1px solid #ddd; padding: 10px 15px; border-radius: 8px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; }
  .connected-badge { color: #27ae60; font-weight: 700; font-size: 0.85rem; display: flex; align-items: center; gap: 5px; }
  .switch-row { display: flex; align-items: center; gap: 10px; font-size: 0.9rem; font-weight: 600; }
  
  .switch { position: relative; display: inline-block; width: 46px; height: 24px; }
  .switch input { opacity: 0; width: 0; height: 0; }
  .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; border-radius: 24px; }
  .slider:before { position: absolute; content: ""; height: 16px; width: 16px; left: 4px; bottom: 4px; background-color: white; transition: .4s; border-radius: 50%; }
  input:checked + .slider { background-color: var(--primary); }
  input:checked + .slider:before { transform: translateX(22px); }
  .help-box {
  background: #f0f7ff;
  border-left: 4px solid #4285F4;
  padding: 12px;
  border-radius: 4px;
  font-size: 0.8rem;
  color: #2c3e50;
  display: flex;
  gap: 10px;
  line-height: 1.4;
}
.help-box i {
  color: #4285F4;
  margin-top: 2px;
}
  @media (max-width: 640px) {
    .config-header {
      flex-direction: column;
      align-items: flex-start;
      padding: 20px;
    }

    .config-icon {
      margin-right: 0;
      margin-bottom: 12px;
    }

    .config-body {
      padding: 20px;
    }

    .gcal-config-row,
    .lembrete-row {
      flex-direction: column;
      align-items: stretch;
    }

    .w-25 {
      width: 100% !important;
    }
  }</style>